/**
 * Ролі акаунтів на клієнті — ДЗЕРКАЛО серверної таблиці (src/lib/roles.ts). Слугує лише для того, щоб
 * приховати недоступне в інтерфейсі; справжній захист — перевірки ролі на сервері (кожен обмежений
 * ендпоінт повертає 403). Змінюючи права, міняйте обидва файли.
 */

export const ROLE_USER = 'user';
export const ROLE_TIER_1 = 'tier_1_subscriber';
export const ROLE_TIER_1_ADMIN = 'tier_1_admin';
export type Role = typeof ROLE_USER | typeof ROLE_TIER_1 | typeof ROLE_TIER_1_ADMIN;

/** Гостьовий акаунт (subs_users.json) — і звичайний tier_1, і tier_1_admin: на сайті в них однакові можливості. */
export function isSubsRole(role: unknown): boolean {
  return role === ROLE_TIER_1 || role === ROLE_TIER_1_ADMIN;
}

export type Feature =
  | 'sources.all'
  | 'overview'
  | 'library.non-novel'
  | 'library.migrate'
  | 'restore.foreign-import'
  | 'restore.own-backup'
  | 'anitube'
  | 'social'
  | 'support.panel';

const ALL: Feature[] = ['sources.all', 'overview', 'library.non-novel', 'library.migrate', 'restore.foreign-import', 'restore.own-backup', 'anitube', 'social'];
const TIER_1: Feature[] = ['restore.own-backup'];

const FEATURES: Record<Role, ReadonlySet<Feature>> = {
  [ROLE_USER]: new Set(ALL),
  [ROLE_TIER_1]: new Set(TIER_1),
  [ROLE_TIER_1_ADMIN]: new Set<Feature>([...TIER_1, 'support.panel']),
};

export function canAccess(role: Role | null | undefined, feature: Feature): boolean {
  return !!role && (FEATURES[role]?.has(feature) ?? false);
}
